<div *ngIf="title" [style.color]="textColor" [style.fontSize.px]="title.size" [style.textAlign]="title.align" class="title">{{title.text}}</div>
<div *ngFor="let dimension of dimensionValues" [ngClass]="dimensionValues.length > 1 ? 'multi' : ''" class="ui statistic">
  <i *ngIf="icons" [ngClass]="icons[dimension.name] || 'circle'" [style.color]="icons[dimension.name] ? dimensionColor : 'transparent'" class="icon"></i>
  <div class="content">
    <div [style.color]="dimensionColor" [style.fontSize.px]="dimensionValue.size" [style.textAlign]="dimensionValue.align" class="value">
      {{dimension.value | format:dimension.format}}
    </div>
    <div *ngIf="dimensionLabel.enabled" [style.fontSize.px]="dimensionLabel.size" [style.textAlign]="dimensionLabel.align" [style.color]="textColor" class="label">{{startCase(dimension.name)}}</div>
  </div>
</div>
<div *ngIf="!!footer" class="dimension-value-footer">
  <span *ngIf="footer.datasetInfo">{{footerData.datasetInfo}}</span>
  <span *ngIf="footer.dateRange">Widget date range: {{footerData.dateRange}}</span>
</div>